import React, { Component } from "react";

import Modal from "../generics/Modal";
import UIIcon from "../generics/UIIcon";
import { logout } from "../../utils/AuthService";
import { withRouter } from "utils/WithRouter";

export class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      openLogoutModal: false,
    };
  }

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  sidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  };

  mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  };

  asideToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("aside-menu-hidden");
  };

  openModal = (e) => {
    this.setState({
      openLogoutModal: true,
    });
  };

  handleConfirm = () => {
    if (this.props.onLogout) {
      this.setState({ openLogoutModal: false });
      this.props.onLogout();
      return;
    }
    logout();
    this.props.history.push("/login");
  };

  render() {
    const { refinedUI } = this.props;
    return (
      <header className="app-header navbar">
        <button className="navbar-toggler mobile-sidebar-toggler hidden-lg-up" onClick={this.mobileSidebarToggle} type="button" aria-label={refinedUI ? "Menu" : undefined}>
          {refinedUI ? <UIIcon name="menu" size={20} /> : "\u2630"}
        </button>
        <a className="navbar-brand" href="#" aria-label={this.props.refinedUI ? "Graziano's" : undefined}></a>
        <ul className="nav navbar-nav hidden-md-down float-left">
          <li className="nav-item">
            <a className="nav-link navbar-toggler sidebar-toggler" onClick={this.sidebarToggle} href="#" aria-label={refinedUI ? "Toggle navigation" : undefined}>
              {refinedUI ? <UIIcon name="menu" size={20} /> : "\u2630"}
            </a>
          </li>
        </ul>
        <ul className="nav navbar-nav ml-auto">
          {this.props.utilitySlot && <li className="nav-item">{this.props.utilitySlot}</li>}
          <li className="nav-item dropdown resp-pr-15">
            <a
              className="nav-link resp-logout"
              data-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
              aria-label={refinedUI ? "Logout" : undefined}
              onClick={this.openModal}
            >
              {refinedUI ? <UIIcon name="logout" size={18} /> : <i className="fa fa-sign-out"></i>} <span className="hidden-xxs-down">Logout</span>
            </a>
          </li>
        </ul>
        <Modal
          className={this.props.refinedUI ? "app-ui-modal--refined" : undefined}
          closeModal={() => this.setState({ openLogoutModal: false })}
          isModalOpen={this.state.openLogoutModal}
          onConfirm={this.handleConfirm}
          onCancel={() => this.setState({ openLogoutModal: false })}
          header="LOG OUT"
          content="Are you sure you want to log out?"
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        />
      </header>
    );
  }
}

export default withRouter(Header);
